<template>
<div class="chapter">
<div class="inner_page">
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">My Dragon, My Knight</span></h1>
<p class="p_normal"> </p>
<p class="p_norm-noindent">By John Inman</p>
<p class="p_normal"> </p>
<p class="p_normal">Danny Sims is in over his head, torn between his abusive lover, Joshua, and Jay Holtsclaw, the bartender up the street, who offers Danny the one thing he never gets at home: understanding.</p>
<p class="p_normal">When Joshua threatens to get rid of Danny’s terrier, Danny knows he has to act fast. Afraid of what Joshua will do to the dog and afraid of what Joshua will do to <span class="calibre2">him</span> if he tries to leave, Danny does the only thing he can do.</p>
<p class="p_normal">He runs.</p>
<p class="p_normal">But Danny isn’t a complete fool. He has enough sense to run into the arms of the man who actually cares for him—the man he’s beginning to trust.</p>
<p class="p_normal">Just as their lives together are starting to fall into place, Danny and Jay learn how vengeful Joshua can be.</p>
<p class="p_normal">And how dangerous.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?a23b502a